import React, { useEffect } from 'react';
import { Container, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MENU_ITEMS } from 'components/views/PublicRoom/_helpers/publicRoom.consts';
import { handleMenuItemClick } from 'components/views/PublicRoom/_helpers/publicRoom.events';
import { $view,$app, $detail } from 'signals/global.signals';
import { Button, Image } from 'react-bootstrap';

const PublicRoomSidebar = () => {
  console.log('$detail.value', $detail.value.userHasAccessToDeal);
  
  return(
    <div
      className={` p-md-24 force-width d-flex flex-column left-menu h-100 bg-dark pt-40 align-items-start ${$app.value.isMenuOpen ? 'expanded' : ''}`}>
      {
        MENU_ITEMS.map((e, i) => {
          const isDisabled = !$detail.value?.userHasAccessToDeal && !e.public;
          
          return (
            <Button
              key={i}
              className={`zoom bg-transparent d-flex align-items-center text-start border-0 mb-40 p-4 ${
                isDisabled ? 'opacity-50' : ''
              }`}
              style={{
                pointerEvents: isDisabled ? 'none' : 'auto',
                cursor: isDisabled ? 'not-allowed' : 'pointer'
              }}
              onClick={() => !isDisabled && handleMenuItemClick({ tab: e.tab })}
              disabled={isDisabled}
            >
              {e.icon && (
                <FontAwesomeIcon icon={e.icon} className="me-8" style={{
                  padding: 0,
                  width: 18,
                  height: 18,
                  display: 'block',
                }} />
              )}
              <span
                className={`${$view.value.activeTab === e.tab ? 'fw-600 m-0 text-gradient-warning-white' : 'fw-300 m-0'}`}
              >
                {e.text}
              </span>
            </Button>
          );
        })
      }
    </div>
  );
}

export default PublicRoomSidebar;